import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/CloseOutlined';
import {Box, Grid, Typography} from '@mui/material';
import PropTypes from 'prop-types';

import {FONT_FAMILIES} from '../../../../../../const';
import Button from '../../../../../form/buttons/Button/Button';

const PartialUpdateHeader = ({onSelectAll, onUnselectAll}) => (
  <Box p={2}>
    <Typography fontSize={15} fontWeight="bold" mb={0.5}>
      Actualisation partielle
    </Typography>
    <Typography fontSize={13} color="text.secondary" mb={2}>
      Sélectionnez les tables à actualiser
    </Typography>

    <Grid container justifyContent="space-between" alignItems="center">
      <Typography fontSize={12}>Tables</Typography>

      <Grid container alignItems="center" gap={1}>
        <Button size="small" startIcon={<CheckIcon />} variant="text" sx={{fontSize: 10, fontFamily: FONT_FAMILIES.BODY}} onClick={onSelectAll}>
          Sélectionner tout
        </Button>

        <Button size="small" startIcon={<CloseIcon />} variant="text" color="error" sx={{fontSize: 10, fontFamily: FONT_FAMILIES.BODY}} onClick={onUnselectAll}>
          Tout désélectionner
        </Button>
      </Grid>
    </Grid>
  </Box>
);

PartialUpdateHeader.propTypes = {
  onSelectAll: PropTypes.func.isRequired,
  onUnselectAll: PropTypes.func.isRequired
};

export default PartialUpdateHeader;
